// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__FocSV","bigColWidth":"Table_bigColWidth__50kMP","biggerColWidth":"Table_biggerColWidth__F-ghr","row":"Table_row__2d44G","col":"Table_col__2sOMp"};